import { connect } from 'react-redux';
import { publishDraftTier } from '../../Tier/redux/creator/actions';
const mapStateToProps = (state)=>({});
const mapDispatchToProps = (dispatch)=>({
        onPublish: (params)=>dispatch(publishDraftTier(params))
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=TierProductCard.container.js.map